//* Libraries imports
import { Download } from "lucide-react";

export type BankSlipData = {
  id: string;
  dueDate: string;
  value: number;
  bankSlipUrl?: string | null;
  status: string;
};

type BankSlipItemProps = {
  item: BankSlipData;
};

export function BankSlipItem({ item }: BankSlipItemProps) {
  const handleDownload = () => {
    if (item.bankSlipUrl) {
      window.open(item.bankSlipUrl, "_blank");
    }
  };

  const formattedValue = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(item.value);

  const formattedDate = new Date(item.dueDate).toLocaleDateString("pt-BR");

  return (
    <div className="flex items-center gap-3 p-3 bg-[#FCFCFC] rounded-xl border border-[#EDF2F6]">
      <div className="flex-1 flex items-center justify-between px-2">
        <span className="text-sm font-semibold text-clarotexto-201">
          Boleto - {formattedDate}
        </span>
        <span className="text-sm font-medium text-clarotexto-201">
          {formattedValue}
        </span>
      </div>
      <button
        onClick={handleDownload}
        disabled={!item.bankSlipUrl}
        className="size-10 flex items-center justify-center rounded-lg bg-blue-50 text-claroprimaria-01 hover:bg-blue-100 transition-colors disabled:opacity-50"
      >
        <Download size={20} />
      </button>
    </div>
  );
}
